import axios from "../../axios/axios";
import { formatarListaComE, parseValor, formatarMoeda, formatarValorCompleto } from "../utils/utilsFormularioEdital";
import { map } from "./map";

export const estadosBrasilPrefixo = {
    BA: "ID.",
    CE: "fls.",
    GO: "mov.",
    MA: "ID.",
    MT: "ID.",
    MS: "fls.",
    MG: "ID.",
    PB: "ID.",
    PR: "mov.",
    PE: "ID.",
    PI: "ID.",
    RJ: "fls.",
    RS: "env.",
    SC: "env.",
    SP: "fls.",
    SE: "fls.",
    TO: "env."
};


const tribunaisPorEstado = {
    AC: 'TJ/AC',
    AL: 'TJ/AL',
    AP: 'TJ/AP',
    AM: 'TJ/AM',
    BA: 'TJ/BA',
    CE: 'TJ/CE',
    DF: 'TJ/DF',
    ES: 'TJ/ES',
    GO: 'TJ/GO',
    MA: 'TJ/MA',
    MT: 'TJ/MT',
    MS: 'TJ/MS',
    MG: 'TJ/MG',
    PA: 'TJ/PA',
    PB: 'TJ/PB',
    PR: 'TJ/PR',
    PE: 'TJ/PE',
    PI: 'TJ/PI',
    RJ: 'TJ/RJ',
    RN: 'TJ/RN',
    RS: 'TJ/RS',
    RO: 'TJ/RO',
    RR: 'TJ/RR',
    SC: 'TJ/SC',
    SP: 'TJ/SP',
    SE: 'TJ/SE',
    TO: 'TJ/TO'
};

export const estadosCodigos = {
    '.8.01.': { nome: 'Acre', sigla: 'AC' },
    '.8.02.': { nome: 'Alagoas', sigla: 'AL' },
    '.8.03.': { nome: 'Amapá', sigla: 'AP' },
    '.8.04.': { nome: 'Amazonas', sigla: 'AM' },
    '.8.05.': { nome: 'Bahia', sigla: 'BA' },
    '.8.06.': { nome: 'Ceará', sigla: 'CE' },
    '.8.07.': { nome: 'Distrito Federal', sigla: 'DF' },
    '.8.08.': { nome: 'Espírito Santo', sigla: 'ES' },
    '.8.09.': { nome: 'Goiás', sigla: 'GO' },
    '.8.10.': { nome: 'Maranhão', sigla: 'MA' },
    '.8.11.': { nome: 'Mato Grosso', sigla: 'MT' },
    '.8.12.': { nome: 'Mato Grosso do Sul', sigla: 'MS' },
    '.8.13.': { nome: 'Minas Gerais', sigla: 'MG' },
    '.8.14.': { nome: 'Pará', sigla: 'PA' },
    '.8.15.': { nome: 'Paraíba', sigla: 'PB' },
    '.8.16.': { nome: 'Paraná', sigla: 'PR' },
    '.8.17.': { nome: 'Pernambuco', sigla: 'PE' },
    '.8.18.': { nome: 'Piauí', sigla: 'PI' },
    '.8.19.': { nome: 'Rio de Janeiro', sigla: 'RJ' },
    '.8.20.': { nome: 'Rio Grande do Norte', sigla: 'RN' },
    '.8.21.': { nome: 'Rio Grande do Sul', sigla: 'RS' },
    '.8.22.': { nome: 'Rondônia', sigla: 'RO' },
    '.8.23.': { nome: 'Roraima', sigla: 'RR' },
    '.8.24.': { nome: 'Santa Catarina', sigla: 'SC' },
    '.8.25.': { nome: 'Sergipe', sigla: 'SE' },
    '.8.26.': { nome: 'São Paulo', sigla: 'SP' },
    '.8.27.': { nome: 'Tocantins', sigla: 'TO' },
};


function mapFrontToEditalBanco(front, estado, envolvidos, juiz, horarioEncerramento, horarioPraceamento, horarioEncerramento2Praca, diaEncerramento2Praca, mesEncerramento2Praca, anoEncerramento2Praca, valor_causa, comissao, somaValorAvaliacao, exequentes, valorDebitoExequendoGlobal, parteTipo, praça, valorHonorariosAdvocaticosGlobal, mostrarFolhasDebitoExequendoGlobal, folhasDebitoExequendoGlobal, temDecisaoDebito, decisaoDebito, folhasDecisaoDebito, possuiParcelamento, percentualEntrada, parcelas, responsabilizacaoFraude, vendaDireta, fazendaExequente, penhoras, bens_apreendidos) {
    // console.log(fazendaExequente)
    const e = front || {};
    const lotesInput = front.lotes || [];


    const edital = {
        tipoParte: parteTipo,
        tipoPraca: praça,
        honorariosAdv: valorHonorariosAdvocaticosGlobal,
        folhas: mostrarFolhasDebitoExequendoGlobal,
        numeroFolhas: folhasDebitoExequendoGlobal,
        // debitosCondominiais: temDecisaoDebito,
        tipoDecisao: decisaoDebito,
        folhasDecisao: folhasDecisaoDebito,
        parcelamento: possuiParcelamento == 'sim' ? true : false,
        percentualEntrada: percentualEntrada,
        parcelas: parcelas,
        responsabilizacaoFraudeLeilao: responsabilizacaoFraude == 'sim' ? true : false,

        debito_exequendo_global: valorDebitoExequendoGlobal,
        processo: front?.processo_numero,
        estado: estado,
        vara: e.VARA,
        foro: e.FORO,
        // edital_titulo_em_negrito: e.edital_titulo_em_negrito,
        // edital_intro: e.edital_intro,
        // executado_blocotexto: e.executado_blocotexto,
        // bloco_bem_como: e.bloco_bem_como,
        genero_juiz: juiz.genero,
        juizo: e.juizo,

        tipoAcaoJudicial: e.acao,

        // executado_blocotexto_sem_conjuge: e.executado_blocotexto_sem_conjuge,
        objeto_do_leilao: e.objeto_do_leilao,
        bens: e.bens,


        // debito_condominial_exequendo: e.debito_condominial_exequendo,
        // debito_condominial: e.debito_condominial,
        // debito_taxa_associativa_exequendo: e.debito_taxa_associativa_exequendo,
        // debito_taxa_associativa: e.debito_taxa_associativa,


        obs_todos_lotes: e.obs_todos_lotes,
        soma_valor_avaliacao_titulo: e.soma_valor_avaliacao_titulo,
        soma_valor_avaliacao_complemento: e.soma_valor_avaliacao_complemento,
        // soma_valor_atualizado_titulo: e.soma_valor_atualizado_titulo,
        // soma_valor_atualizado_complemento: e.soma_valor_atualizado_complemento,
        // debito_exequendo_simples: e.debito_exequendo_simples,
        praca_resumida: e.praca_resumida, // não vem
        dia_praceamento: e.dia_praceamento,
        mes_praceamento: e.mes_praceamento,
        ano_praceamento: e.ano_praceamento,
        horario_praceamento: horarioPraceamento,
        dia_encerramento: e.dia_encerramento,
        mes_encerramento: e.mes_encerramento,
        ano_encerramento: e.ano_encerramento,
        horario_encerramento: horarioEncerramento,
        percentual_lance: e.percentual_lance,
        resguardar_quota_parte: Boolean(e.resguardar_quota_parte),
        condicoes_venda_parcelamento: Boolean(e.condicoes_venda_parcelamento),
        comissao,
        // excecao_condominio: Boolean(e.excecao_condominio), // não vem
        dia_confeccao: e.dia_confeccao,
        mes_confeccao: e.mes_confeccao,
        doutor_titulo_maiusculo: e.doutor_titulo_maiusculo,
        juizo_maiusculo: e.juizo_maiusculo,
        juiz_titulo_maiusculo: e.juiz_titulo_maiusculo,
        // valor_causa: e.valor_causa, // não está vindo
        cep: lotesInput[0]?.cep,
        logradouro: lotesInput[0]?.logradouro,
        numero: lotesInput[0]?.numero,
        complemento: lotesInput[0]?.complemento,
        bairro: lotesInput[0]?.bairro,
        cidade: lotesInput[0]?.cidade,
        horario_encerramento_2praca: horarioEncerramento2Praca,
        mes_encerramento_2praca: mesEncerramento2Praca,
        dia_encerramento_2praca: diaEncerramento2Praca,
        ano_encerramento_2praca: anoEncerramento2Praca,
        venda_direta: vendaDireta == 'sim' ? true : false,
        penhoras,
        bens_apreendidos: bens_apreendidos == 'sim' ? true : false
    };

    if (['PB', 'MS'].includes(estado)) {
        edital['fazendaPublicaExequente'] = fazendaExequente
    }

    const pessoasEnvolvidas = envolvidos;
    const exequentesJudiciais = exequentes

    const lotes = lotesInput.map(lote => ({
        // indice: lote.indice,        
        descricao: lote.descricao,
        // dados veiculo
        veiculo: lote.veiculo,
        placa: lote.placa,
        chassi: lote.chassi,
        anoModelo: lote.anoModelo,
        cor: lote.cor,
        renavam: lote.renavam,
        combustivel: lote.combustivel,
        potenciaCilindradas: lote.potenciaCilindradas,
        marca: lote.marca,

        // valor Avaliação
        valorAvaliacao: lote.valor_avaliacao,
        valorAvaliacaoMes: lote.mes,
        valorAvaliacaoAno: lote.ano,
        folhasAvaliacao: lote.folhas_homologacao,
        homologado: true,
        folhasHomologacao: lote.folhas_homologacao,

        // debito tributarios
        debitoTributario: lote.tem_debitos_tributarios,
        ...((lote.tem_debitos_tributarios) && {
            debitoTributarioDetalhes: lote.debitos_tributarios,
        }),
        
        // data_consulta:
        data_consulta: lote.data_consulta,

        // recall
        tem_recall: lote.tem_recall,
        ...((lote.tem_recall) && {
            recall: lote.recall
        }),

        // fiel depositario
        fiel_depositario: lote.fiel_depositario,
        fiel_doc: lote.fiel_doc,
        tipo_doc_fiel: lote.tipo_doc_fiel,



        cep: lote.cep,
        logradouro: lote.logradouro,
        numero: lote.numero,
        complemento: lote.complemento,
        bairro: lote.bairro,
        cidade: lote.cidade,
        estado: lote.estado,
        onus: lote.onus || [],
        observacoes: lote.observacoes.map((obs, idx) => ({
            numero: lote.observacoes.length > 1 ? `${String(idx + 1).padStart(2, "0")}:` : "",
            texto: typeof obs === "string" ? obs : obs.texto,
        })),
    }));

    return { edital, pessoasEnvolvidas, lotes, exequentesJudiciais };
}

const mappedFields = [
    "nome",
    "cpfCnpj",
    "tipo",
    "cep",
    "numero",
    "complemento",
    "bairro",
    "cidade",
    "logradouro"
];
const convert = (envolvidos) => {
    return envolvidos.map(pessoa => {
        const converted = {};
        mappedFields.forEach(field => {
            if (field == 'cpfCnpj') {
                converted[field] = pessoa['doc'] || pessoa['doc_executado'] || ''
            } else if (field == 'nome') {
                converted[field] = pessoa['nome'] || pessoa['executado']
            }
            else {
                converted[field] = pessoa[field];
            }

            if (pessoa.conjuge) {
                converted.conjuge = { create: { ...pessoa.conjuge } }
            }
        });
        return converted;
    });
}


export const handleGerarEditalVeiculo = async (executados,
    formatarListaComE,
    gerarTitulo,
    parteTipo,
    generoTitulo,
    objetoLeilao,
    doutorTitulo,
    acao,
    partePrincipal,
    docPartePrincipal,
    processoNumero,
    tipoBens,
    localizacaoLote1, // Manter por enquanto, mas a lógica abaixo usará 'lotes'
    descricaoLote1,   // Manter por enquanto, mas a lógica abaixo usará 'lotes'
    mes, // Verificar se ainda é usado ou remover
    mesPraceamento,
    mesAtualizado, // Verificar se ainda é usado ou remover
    temDecisaoDebito,
    decisaoDebito,
    folhasDecisaoDebito, // Nome corrigido
    resguardarQuota,
    credor,
    mostrar,
    percentualLance,
    interessado,
    possuiParcelamento,
    percentualEntrada,
    parcelas,
    tem_debitos_tributarios, // Manter por enquanto, se for global
    valorDebitosTributarios, // Manter por enquanto, se for global
    abreviarMes,
    mesDebitosTributarios, // Manter por enquanto, se for global
    anoDebitosTributarios, // Manter por enquanto, se for global
    valorDebitosTributariosInscritos, // Manter por enquanto, se for global
    valorDebitosTributariosNaoInscritos, // Manter por enquanto, se for global
    vendaDireta,
    praça,
    // Novos argumentos globais para débito exequendo:
    valorDebitoExequendoGlobal,
    mesDebitoExequendoGlobal,
    anoDebitoExequendoGlobal,
    mostrarFolhasDebitoExequendoGlobal,
    folhasDebitoExequendoGlobal,
    valorHonorariosAdvocaticosGlobal,
    // Penhoras (array)
    penhoras,
    diaEncerramento,
    mesEncerramento,
    anoEncerramento,
    horarioEncerramentoExtenso,
    diaEncerramento2Praca,
    mesEncerramento2Praca,
    anoEncerramento2Praca,
    horarioEncerramento2PracaExtenso,
    // Argumentos de data/horário
    diaPraceamento,
    anoPraceamento,
    horarioParaExtenso, // Função utilitária
    horarioPraceamento,
    horarioEncerramento,
    horarioEncerramento2Praca,
    horarioPraceamentoExtenso,
    // Array de lotes (agora contém info de débitos por lote)
    lotes,
    foiHomologado,
    comissao,
    comissaoPorExtenso,
    juiz,
    vara,
    foro,
    diaConfeccao,
    mesConfeccao,
    temObsTodosLotes,
    obsTodosLotes,
    somaValorAvaliacao,
    somaValorAtualizado,
    // Utilitários e outros:
    PizZip,
    Docxtemplater,
    saveAs,
    responsabilizacaoFraude,
    formatarMoeda,
    exequentes,
    setExequentes,
    estado,
    valor_causa,
    indice,
    numInds,
    fazendaExequente,
    bens_apreendidos
) => {
    const resultado = {};
    fazendaExequente = fazendaExequente == 'sim' ? true : false

    console.log('PESSOAS ENVOLVIDAS ABAIXO')
    console.log('executados', executados, 'iteressaods', interessado, 'credor', credor)
    const convertedFieldsPessoas = convert([...executados.map((e) => {
        e.tipo = 'EXECUTADO'
        return e
    }), ...interessado.map((e) => {
        e.tipo = 'TERCEIRO'
        return e
    }), ...credor.map((e) => {
        e.tipo = 'CREDOR'
        return e
    })])
    // passar tipo   
    console.log('convertedFieldsPessoas', convertedFieldsPessoas)


    console.log("Valores recebidos em handleGerar:");
    console.log("tem_debitos_tributarios:", tem_debitos_tributarios);
    console.log("valorDebitosTributarios:", valorDebitosTributarios);
    console.log("mesDebitosTributarios:", mesDebitosTributarios);
    console.log("anoDebitosTributarios:", anoDebitosTributarios);
    console.log("valorDebitosTributariosInscritos:", valorDebitosTributariosInscritos);
    console.log("valorDebitosTributariosNaoInscritos:", valorDebitosTributariosNaoInscritos);
    console.log("lotes:", lotes); // Para verificar os dados de débito por lote
    console.log("valorDebitoExequendoGlobal:", valorDebitoExequendoGlobal); // Para verificar o débito global
    console.log("penhoras:", penhoras); // Para verificar o array de penhoras
    console.log("diaPraceamento:", diaPraceamento); // Para verificar as datas
    console.log("mesPraceamento:", mesPraceamento);
    console.log("anoPraceamento:", anoPraceamento);
    console.log("diaEncerramento:", diaEncerramento);
    console.log("mesEncerramento:", mesEncerramento);
    console.log("anoEncerramento:", anoEncerramento);
    console.log("diaEncerramento2Praca:", diaEncerramento2Praca);
    console.log("mesEncerramento2Praca:", mesEncerramento2Praca);
    console.log("anoEncerramento2Praca:", anoEncerramento2Praca);
    console.log("horarioPraceamentoExtenso:", horarioPraceamentoExtenso);
    console.log("horarioEncerramentoExtenso:", horarioEncerramentoExtenso);
    console.log("horarioEncerramento2PracaExtenso:", horarioEncerramento2PracaExtenso);

    // --- Processamento de Dados Gerais ---
    const listaExecutadosFmt = executados.map((e) => {
        const base = `${e.executado} (CPF/CNPJ Nº ${e.doc_executado})`;
        if (e.tem_conjuge && e.conjuge) {
            return `${base}, e seu cônjuge,${e.conjuge} (CPF/CNPJ Nº ${e.doc_conjuge})`;
        } else {
            return `${base}, se casado for;`;
        }
    });
    resultado.executado_blocotexto = formatarListaComE(listaExecutadosFmt);

    resultado.executado_titulo = gerarTitulo(parteTipo, executados, generoTitulo.executado);
    resultado.objeto_do_leilao = objetoLeilao;
    resultado.doutor_titulo = doutorTitulo;
    resultado.acao = acao;
    resultado.exequente_requerente = exequentes.map((ex) => `${ex.nome} (CPF/CNPJ Nº ${ex.doc})`).join(', ')
    resultado.processo_numero = processoNumero;
    resultado.bens = tipoBens;
    resultado.bens_apreendidos = bens_apreendidos == 'sim' ? true : false;
    // localizacaoLote1 e descricaoLote1 não são mais usados se houver múltiplos lotes,
    // a descrição dos lotes será gerada a partir do array 'lotes' mais abaixo.
    // Mantidos aqui apenas para compatibilidade caso o template ainda os use fora do loop de lotes.
    resultado.localizacao_lote1 = localizacaoLote1;
    resultado.descrição_lote1 = descricaoLote1;
    resultado.ano_confeccao= new Date().getFullYear();


    // Meses gerais (verificar se ainda são necessários no template)
    resultado.mes = mes;
    // resultado.mes_praceamento = mesPraceamento; // Será sobrescrito pelas datas formatadas abaixo
    // resultado.mes_atualizado = mesAtualizado; // Será sobrescrito pelas datas formatadas abaixo

    //   resultado.decisao_debitos = temDecisaoDebito ? decisaoDebito : "";
    //   resultado.folhas_debitos_condominiais = temDecisaoDebito ? folhasDecisaoDebito : ""; // Usar o parâmetro renomeado

    resultado.resguardar_quota_parte = resguardarQuota === "resguardar"
        ? "de modo que o deságio recairá apenas sobre a quota-parte do executado (artigo 843, do CPC)."
        : "";

    const listaExecutadosSemConjuge = executados.map((e) =>
        `${e.executado} (CPF/CNPJ Nº ${e.doc_executado})`
    );
    resultado.executado_blocotexto_sem_conjuge = formatarListaComE(listaExecutadosSemConjuge);

    const listaCredor = credor.filter((p) => p.nome && p.doc);
    if (mostrar.credor && listaCredor.length > 0) {
        resultado.credor_titulo = gerarTitulo("credor", listaCredor, generoTitulo.credor) + ": ";
        resultado.credor_blocotexto = formatarListaComE(
            listaCredor.map((p) => `${p.nome} (CPF/CNPJ Nº ${p.doc})`)
        ) + "; ";
    } else {
        resultado.credor_titulo = "";
        resultado.credor_blocotexto = "";
    }

    resultado.percentual_lance = percentualLance ? `${percentualLance}%` : "";

    const listaCredorFmt = listaCredor.map((p) => `${p.nome} (CPF/CNPJ Nº ${p.doc})`);


    const listaInteressado = interessado.filter((p) => p.nome && p.doc);
    if (mostrar.interessado && listaInteressado.length > 0) {
        resultado.interessados_titulo = gerarTitulo("terceiro interessado", listaInteressado, generoTitulo.interessado) + ": ";
        resultado.interessados_blocotexto = formatarListaComE(
            listaInteressado.map((p) => `${p.nome} (CPF/CNPJ Nº ${p.doc})`)
        );
    } else {
        resultado.interessados_titulo = "";
        resultado.interessados_blocotexto = "";
    }

    const estadosComIndice = ['MS', 'CE', 'MT', 'PE', 'RS', 'TO', 'SE']

    let condicoesVenda = "";

    if (possuiParcelamento === "sim") { // map[estado].item03(percentualEntrada, parcelas)
        if (estado == 'PR') {
            if (numInds == '2') {
                condicoesVenda = map['PR'].item03[2]
            } else {
                condicoesVenda = map['PR'].item03[1](percentualEntrada, parcelas, indice)
            }
        } else {
            console.log(estado, 'aqui')
            condicoesVenda = map[estado].item03(percentualEntrada, parcelas)
            if (estadosComIndice.includes(estado)) {
                condicoesVenda = map[estado].item03(percentualEntrada, parcelas, indice)
            }
        }

        // condicoesVenda = `. Caso não haja propostas para pagamento à vista, serão admitidas propostas de arrematação parcelada** exclusivamente eletrônicas pelo sítio eletrônico da gestora (www.alfaleiloes.com), sendo necessário sinal não inferior a ${percentualEntrada || "25%"} do valor da proposta e o restante em até ${parcelas || "30"} parcelas mensais e iguais (podendo oscilar de acordo com a atualização monetária). O saldo devedor (parcelado) sofrerá correção mensal pelo índice do E. TJ/SP e será garantido por hipoteca do próprio bem, quando se tratar de imóveis. Havendo mais de uma proposta de pagamento parcelado, em diferentes condições, será declarada vencedora a proposta mais vantajosa, assim compreendida, de maior valor; ou em propostas de iguais condições, será declarada vencedora a proposta formulada em primeiro lugar. (artigo 891, parágrafo único, artigo 895, §§ 1º ao 8º do CPC).`;
    } else {
        condicoesVenda = "";
    }

    resultado.condicoes_venda_parcelamento = condicoesVenda;


    const bensComMaiuscula = tipoBens.charAt(0).toUpperCase() + tipoBens.slice(1);
    resultado.bens = bensComMaiuscula;

    const listaInteressadoFmt = listaInteressado.map((p) => `${p.nome} (CPF/CNPJ Nº ${p.doc})`);


    let textoVendaDireta = "";
    let numeroVendaDireta = "";
    let numeroDuvidas = "";
    let numeroPublicacao = "";

    if (vendaDireta === "sim") {
        textoVendaDireta = map[estado].item17
        numeroVendaDireta = map[estado].numeroVendaDireta; // map[Sigla].numeroVendaDireta
        numeroDuvidas = String(+numeroVendaDireta + 1);
        numeroPublicacao = String(+numeroDuvidas + 1);
    } else {
        textoVendaDireta = "";
        numeroVendaDireta = ""; // Não mostra o item
        numeroDuvidas = map[estado].numeroVendaDireta; // map[Sigla].numeroVendaDireta
        numeroPublicacao = String(+numeroDuvidas + 1);// map[Sigla].numeroVendaDireta + 1
    }

    resultado.texto_venda_direta = textoVendaDireta;
    resultado.numero_venda_direta = numeroVendaDireta;
    resultado.numero_duvidas = numeroDuvidas;
    resultado.numero_publicacao = numeroPublicacao;

    resultado.PRAÇA = praça;

    // Monta o texto do edital conforme a regra do "bem como"
    let blocoCredor = resultado.credor_titulo && resultado.credor_blocotexto ? resultado.credor_titulo + resultado.credor_blocotexto : "";
    let blocoInteressado = resultado.interessados_titulo && resultado.interessados_blocotexto ? resultado.interessados_titulo + resultado.interessados_blocotexto : "";

    let blocoBemComo = "";

    if (mostrar.credor && listaCredorFmt.length) {
        blocoBemComo += ` bem como do credor: ${formatarListaComE(listaCredorFmt)};`;
    }

    if (mostrar.interessado && listaInteressadoFmt.length) {
        blocoBemComo += ` do terceiro interessado: ${formatarListaComE(listaInteressadoFmt)}.`;
    }


    resultado.edital_titulo_em_negrito = `EDITAL DE HASTA PÚBLICA (${praça})`;
    resultado.edital_intro = ` do bem imóvel abaixo descrito, para conhecimento de eventuais interessados e para intimação do executado:`;
    resultado.executado_blocotexto = formatarListaComE(listaExecutadosFmt); // já vem com os **negritos** aplicados

    if (estado == 'PR') {
        resultado.valor_causa = formatarValorCompleto(valor_causa)
    }

    if (indice?.length > 0 && numInds == '1' && estado != 'PR') {
        resultado.indice_avaliacao = indice
    }


    if (indice?.length > 0 && numInds == '1' && estado == 'PR') {
        resultado.indice_avaliacao = `do índice ${indice}`
    }

    if (numInds == '2' && estado == 'PR') {
        resultado.indice_avaliacao = `da média dos índices do INPC e IGP-DI`
    }




    let blocoBemComoFinal = "";

    if (mostrar.credor && listaCredorFmt.length) {
        const listaCredorNegrito = formatarListaComE(
            listaCredor.map((p) => `${p.nome} (CPF/CNPJ Nº ${p.doc})`)
        );
        blocoBemComoFinal += ` bem como do credor: ${listaCredorNegrito};`;
    }

    if (mostrar.interessado && listaInteressadoFmt.length) {
        const listaInteressadoNegrito = formatarListaComE(
            listaInteressado.map((p) => `${p.nome} (CPF/CNPJ Nº ${p.doc})`)
        );
        blocoBemComoFinal += ` do terceiro interessado: ${listaInteressadoNegrito}.`;
    }

    resultado.bloco_bem_como_negrito = blocoBemComoFinal;


    let debito_exequendo_global_texto = ""; // Corresponde à tag {{debito_exequendo_simples}}


    // Lógica de exclusividade para débitos exequendos e fallback para não exequendos
    if (valorDebitoExequendoGlobal) {
        // Gerar texto para débito exequendo GLOBAL (se não houver por lote)
        let texto = "";
        if (valorDebitoExequendoGlobal) {
            texto += `R$ ${formatarMoeda(parseValor(valorDebitoExequendoGlobal))} referente aos débitos`; // Ajuste a descrição conforme necessário
            if (mesDebitoExequendoGlobal || anoDebitoExequendoGlobal) {
                texto += ` (${abreviarMes(mesDebitoExequendoGlobal)}/${anoDebitoExequendoGlobal})`;
            }
        }
        if (valorHonorariosAdvocaticosGlobal) {
            texto += `${texto ? " e " : ""}${formatarMoeda(parseValor(valorHonorariosAdvocaticosGlobal))} referente aos honorários advocatícios`;
        }
        texto += ". ";
        if (mostrarFolhasDebitoExequendoGlobal && folhasDebitoExequendoGlobal) {
            texto += `Os débitos ficarão sub-rogados no valor da arrematação (artigo 908, §1°, do CPC e Decisão de ${estadosBrasilPrefixo[estado]} ${folhasDebitoExequendoGlobal}).`;
        } else {
            texto += "Os débitos ficarão sub-rogados no valor da arrematação (artigo 908, §1°, do CPC).";
        }
        debito_exequendo_global_texto = texto;
    }


    // Atribuir os textos gerados às propriedades do resultado
    // resultado.debito_condominial_exequendo = debito_condominial_exequendo_texto;
    // resultado.debito_condominial = debito_condominial_texto;
    // resultado.debito_taxa_associativa_exequendo = debito_taxa_associativa_exequendo_texto;
    // resultado.debito_taxa_associativa = debito_taxa_associativa_texto;
    resultado.debito_exequendo_simples = debito_exequendo_global_texto; // Corresponde à tag {{debito_exequendo_simples}}

    // Parte "bem como do credor:" em texto comum
    let bloco_bem_como = '';
    let credor_negrito = '';
    let terceiro_interessado = '';
    let terceiro_interessado_negrito = '';

    if (mostrar.credor && listaCredor.length) {
        bloco_bem_como = ' bem como do credor:';
        credor_negrito = formatarListaComE(
            listaCredor.map((p) => `${p.nome} (CPF/CNPJ Nº ${p.doc})`)
        ) + ';';
    }

    if (mostrar.interessado && listaInteressado.length) {
        terceiro_interessado = ' do terceiro interessado:';
        terceiro_interessado_negrito = formatarListaComE(
            listaInteressado.map((p) => `${p.nome} (CPF/CNPJ Nº ${p.doc})`)
        ) + '.';
    }

    resultado.bloco_bem_como = bloco_bem_como;
    resultado.credor_negrito = credor_negrito;
    resultado.terceiro_interessado = terceiro_interessado;
    resultado.terceiro_interessado_negrito = terceiro_interessado_negrito;



    // --- Processamento de Penhoras ---
    // O template usa um loop {{#penhoras}} com campos individuais,
    // então precisamos formatar o array penhoras para isso.
    resultado.penhoras = penhoras.map(p => ({
        pedidoDePenhora: p.pedidoDePenhora || "",
        anotacaoPenhora: p.anotacaoPenhora || "",
        valorPenhora: p.valorPenhora || "",
        mesPenhora: abreviarMes(p.mesPenhora) || "",
        anoPenhora: p.anoPenhora || "",
        processoDaPenhora: p.processoDaPenhora || "",
        credorPenhora: p.credorPenhora || ""
    })).filter(p => Object.values(p).some(val => val !== "")); // Remove objetos de penhora vazios


    // --- Processamento de Datas e Horários ---
    resultado.dia_praceamento = diaPraceamento || "";
    resultado.mes_praceamento = mesPraceamento || ""; // Usar o nome completo do mês para a tag
    resultado.ano_praceamento = anoPraceamento || "";
    resultado.horario_praceamento_extenso = horarioPraceamentoExtenso || "";

    resultado.dia_encerramento = diaEncerramento || "";
    resultado.mes_encerramento = mesEncerramento || ""; // Usar o nome completo do mês para a tag
    resultado.ano_encerramento = anoEncerramento || "";
    resultado.horario_encerramento_extenso = horarioEncerramentoExtenso || "";

    resultado.dia_encerramento_2praca = diaEncerramento2Praca || "";
    resultado.mes_encerramento_2praca = mesEncerramento2Praca || ""; // Usar o nome completo do mês para a tag
    resultado.ano_encerramento_2praca = anoEncerramento2Praca || "";
    resultado.horario_encerramento_2praca_extenso = horarioEncerramento2PracaExtenso || "";

    if (praça === "praça Única") {
        resultado.PRAÇA_RESUMIDA = "Praça Única";
    } else {
        resultado.PRAÇA_RESUMIDA = "1ª Praça";
    }

    if (praça === "1ª e 2ª praça") {
        const texto2pracaNormal = "Não havendo lance igual ou superior à avaliação nos 3 (três) dias subsequentes ao início da 1ª Praça, a ";
        const texto2pracaNegrito = `2ª Praça seguir-se-á sem interrupção, iniciando-se em ${resultado.dia_encerramento} de ${resultado.mes_encerramento} de ${resultado.ano_encerramento}, às ${resultado.horario_encerramento_extenso}, e se encerrará em ${resultado.dia_encerramento_2praca} de ${resultado.mes_encerramento_2praca} de ${resultado.ano_encerramento_2praca}, às ${resultado.horario_encerramento_2praca_extenso}.`;
        resultado.texto_2praca_normal = texto2pracaNormal;
        resultado.texto_2praca_negrito = texto2pracaNegrito;
    } else {
        resultado.texto_2praca_normal = "";
        resultado.texto_2praca_negrito = "";
    }


    // --- Processamento de Lotes para o Loop no Template ---
    resultado.lotes = lotes.map((lote, i) => {
        // :marca_de_verificação_branca: Padroniza o valor e evita erro por maiúsculas, espaços ou undefined
        const foiHomologado = String(lote.foiHomologado || "").trim().toLowerCase() === "sim";
        // :marca_de_verificação_branca: Garante que não quebre se a folha da homologação estiver vazia
        const flsHomologacao = lote.folhas_homologacao ? ` – Homologação às ${estadosBrasilPrefixo[estado]} ${lote.folhas_homologacao}` : "";
        // :marca_de_verificação_branca: Monta o valor com ou sem homologação
        const valor_avaliacao_texto = foiHomologado
            ? `${formatarMoeda(parseValor(lote.valor_avaliacao))} (${abreviarMes(lote.mes)}/${lote.ano} – Avaliação às ${estadosBrasilPrefixo[estado]} ${lote.folhas_avaliacao}${flsHomologacao}).`
            : `${formatarMoeda(parseValor(lote.valor_avaliacao))} (${abreviarMes(lote.mes)}/${lote.ano} – Avaliação às ${estadosBrasilPrefixo[estado]} ${lote.folhas_avaliacao}).`;



        return {
            ...lote,
            indice: String(i + 1).padStart(2, "0"),
            valor_avaliacao_texto: valor_avaliacao_texto,
            debitos_tributarios: lote.debitos_tributarios || "",
            tem_recall: lote.tem_recall == 'sim' ? true : false,
            tem_debitos_tributarios: lote.tem_debitos_tributarios == 'sim' ? true : false,
            tem_observacao: lote?.observacoes?.length >= 1,
            // :apontando_para_baixo: O restante do seu return continua igual
            onus: lote.onus.map((item) => ({
                restricao: String(item.restricao || ""),
                data: [item.dia, item.mes, item.ano].filter(Boolean).join("/") || "",
                processo: String(item.processo || ""),
                credor: String(item.credor || ""),
            })).filter(item => Object.values(item).some(val => val !== "")),
            observacoes: lote.observacoes // mecher aqui
                .map((o) => typeof o === "string" ? o : String(o))
                .filter((o) => o.trim() !== "")
                .map((o, idx) => ({
                    prefixo: "OBS",
                    numero: (lote.observacoes.length === 1 && estado != 'CE') ? "" : `${String(idx + 1 + (lote.tem_recall == 'sim' ? 2 : 1)).padStart(2, "0")}:`,
                    texto: o.trim()
                })),
            // Adicionar débitos específicos do lote se necessário no template do lote
            // Ex: debito_condominial_lote: lote.temDebitoCondominial === 'sim' ? '...' : '',
            // Mas a lógica atual os trata em blocos separados fora do loop de lotes.
        };
    });

    // --- Processamento de Observações Globais ---
    let obsTodosLotesTexto = "";
    if (temObsTodosLotes && obsTodosLotes.some(o => o.trim() !== "")) {
        if (obsTodosLotes.length === 1) {
            obsTodosLotesTexto = `OBSERVAÇÕES PARA TODOS OS LOTES: ${obsTodosLotes[0]}`;
        } else {
            obsTodosLotesTexto = "OBSERVAÇÕES PARA TODOS OS LOTES:\n\n" +
                obsTodosLotes
                    .map((obs, i) => obs.trim() ? `OBS. ${String(i + 1).padStart(2, "0")}: ${obs}` : "")
                    .filter(Boolean)
                    .join("\n\n");
        }
    }
    // A tag no template é {{obs_todos_lotes}}, então atribuímos o texto formatado a ela.
    resultado.obs_todos_lotes = obsTodosLotesTexto;



    let textoFraudeLeilaoGerado = responsabilizacaoFraude == 'sim' ? 'Em hipótese alguma será permitida a desistência da arrematação. No caso de não pagamento do valor do bem arrematado, e da comissão devida à do leiloeiro no prazo estipulado, pode configurar fraude em leilão (artigo 358 do Código Penal). Neste caso, o participante responderá civil e criminalmente, ficando ainda obrigado, nos termos do item 09, a pagar a comissão sobre o lance ofertado em favor do leiloeiro oficial, a título de multa. Fica nesta hipótese autorizado o leiloeiro a receber e aprovar os lanços imediatamente anteriores, desde que obedecidos os limites e regras estabelecidas no presente edital.' : 'Em hipótese alguma será permitida a desistência da arrematação. No caso de não pagamento do valor do bem arrematado, e da comissão devida à do leiloeiro no prazo estipulado, pode configurar fraude em leilão (artigo 358 do Código Penal). Neste caso, o participante responderá civil e criminalmente. Fica nesta hipótese autorizado o leiloeiro a receber e aprovar os lanços imediatamente anteriores, desde que obedecidos os limites e regras estabelecidas no presente edital.'

    if (map[estado]?.fraude_leilao?.[responsabilizacaoFraude]) {
        textoFraudeLeilaoGerado = map[estado]?.fraude_leilao?.[responsabilizacaoFraude]
    }

    resultado.texto_fraude_leilao = textoFraudeLeilaoGerado



    // --- Processamento de Soma de Valores (se houver múltiplos lotes) ---
    const infoPrimeiroLote = lotes[0] || {}; // Usar info do primeiro lote para datas/folhas na soma

    let textoSomaAvaliacao = "";
    //   let textoSomaAvaliacaoAtualizada = "";

    if (lotes.length > 1) {
        // Avaliação normal
        const mesAvaliacao = abreviarMes(infoPrimeiroLote.mes);
        const anoAvaliacao = infoPrimeiroLote.ano || "";
        const folhasAvaliacao = infoPrimeiroLote.folhas_avaliacao ? ` – Avaliação ao ${estadosBrasilPrefixo[estado]} ${infoPrimeiroLote.folhas_avaliacao}` : "";
        const folhasHomologacao = foiHomologado === "sim" && infoPrimeiroLote.folhas_homologacao ? ` – Homologação ao ${estadosBrasilPrefixo[estado]} ${infoPrimeiroLote.folhas_homologacao}` : "";
        textoSomaAvaliacao = `${formatarMoeda(somaValorAvaliacao)} (${mesAvaliacao}/${anoAvaliacao}${folhasAvaliacao}${folhasHomologacao}).`;
    }

    // Atribuir os textos de soma às propriedades do resultado
    if (lotes.length > 1) {
        resultado.soma_valor_avaliacao_titulo = "VALOR DE AVALIAÇÃO DE TODOS OS LOTES:";
        resultado.soma_valor_avaliacao_complemento = textoSomaAvaliacao;
    } else {
        resultado.soma_valor_avaliacao_titulo = "";
        resultado.soma_valor_avaliacao_complemento = "";
    }


    // --- Processamento de Informações do Juiz e Local/Data de Assinatura ---
    resultado.comissão = comissao;
    resultado.comissao_por_extenso = comissaoPorExtenso;

    resultado.juizo = juiz.nome;
    resultado.juiz_titulo = juiz.genero === "f" ? "juíza" : "juiz";
    resultado.comeco_titulo = juiz.genero === "f" ? "A" : "O";
    // resultado.doutor_titulo já está definido no início
    resultado.doutor_titulo_maiusculo = (resultado.doutor_titulo || "").toUpperCase();
    resultado.juizo_maiusculo = (resultado.juizo || "").toUpperCase();
    resultado.juiz_titulo_maiusculo = (resultado.juiz_titulo || "").toUpperCase();

    resultado.percentual_entrada = percentualEntrada;
    resultado.parcelas = parcelas;

    resultado.VARA = vara;
    resultado.FORO = foro;
    // resultado.PRAÇA já está definido
    resultado.UF = "SP";
    // resultado.processo_numero já está definido
    resultado.LOCAL_ASSINATURA = "São Paulo"; // Manter fixo ou tornar configurável?
    // resultado.DATA_ASSINATURA = "20 de maio de 2025"; // Manter fixo ou tornar configurável?

    resultado.dia_confeccao = diaConfeccao || "";
    resultado.mes_confeccao = abreviarMes(mesConfeccao) || "";
    // Se quiser a data completa por extenso para a assinatura:
    resultado.data_confeccao_extenso = diaConfeccao && mesConfeccao ? `${diaConfeccao} de ${mesConfeccao} de ${new Date().getFullYear()}` : ""; // Assumindo ano atual


    // --- Geração do Documento ---
    console.log("Dados enviados para o template:", resultado); // Log para depuração

    try {
        // let path = "/templates/editais_veiculo/Edital_Veiculo_SP.docx";
        let path = map[estado].caminho_veiculo
        console.log(path)
        // if (['PB', 'MS'].includes(estado) && !fazendaExequente) {
        //   path = `/templates/editais_imovel/Edital_${estado}_COMPLETO_TAGS_SEM_LEI.docx`
        // }

        const response = await fetch(path);
        const content = await response.arrayBuffer();
        const zip = new PizZip(content);
        const doc = new Docxtemplater(zip, {
            paragraphLoop: true,
            linebreaks: true,
            delimiters: { start: "{{", end: "}}" },
            nullGetter: () => "", // Garante que tags sem valor fiquem vazias
        });


        doc.render(resultado);

        // console.log(doc.getFullText());

        const blob = doc.getZip().generate({
            type: "blob",
            mimeType:
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });

        saveAs(blob, `Edital_${estado}_Preenchido.docx`);


        const objetoFormatado = mapFrontToEditalBanco(resultado, estado, convertedFieldsPessoas, juiz, horarioEncerramento, horarioPraceamento, horarioEncerramento2Praca, diaEncerramento2Praca, mesEncerramento2Praca, anoEncerramento2Praca, valor_causa, comissao, somaValorAvaliacao, exequentes, valorDebitoExequendoGlobal, parteTipo, praça, valorHonorariosAdvocaticosGlobal, mostrarFolhasDebitoExequendoGlobal, folhasDebitoExequendoGlobal, temDecisaoDebito, decisaoDebito, folhasDecisaoDebito, possuiParcelamento, percentualEntrada, parcelas, responsabilizacaoFraude, vendaDireta, fazendaExequente, penhoras, bens_apreendidos);

        console.log('objetoFormatado', objetoFormatado)

        console.log('salvando no banco')
        const { data } = await axios.post('/editais/veiculo', objetoFormatado)
        console.log(data, 'salvo no banco')


    } catch (error) {
        console.error("Erro ao gerar o documento:", error);
    }
};
